<template>
  <transition name="moin-teaser-closebutton-transition" appear>
    <slot />
  </transition>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
/* CLOSE TEASER TRANSITION */
.moin-teaser-closebutton-transition-enter-from {
  opacity: 0;
}

.moin-teaser-closebutton-transition-enter-active {
  transition: opacity $kw-default-transition-speed-slow linear 2s;
}

.moin-teaser-closebutton-transition-enter-to {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  // TODO: Add styles for reduced motion

}
</style>
